export default __webpack_public_path__ + "media/images/iui/listArrow-01e23212a1f360066abaf5cdf4e7f085.png";